exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about[data-v-6bc4047c]{width:100%}.about .body[data-v-6bc4047c]{display:flex;flex-direction:column}.about .body .bg[data-v-6bc4047c]{width:100%;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bc4047c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/curriculum.vue
// module id = 201
// module chunks = 0